import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetStatusSnapshotsQuery } from './get-status-snapshots.query';
import { GetStatusSnapshotsResult } from './get-status-snapshots.result';

/**
 * Get status snapshots use case.
 * Retrieves available status options for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetStatusSnapshotsUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the get status snapshots use case.
   * @param query - Query containing case ID
   * @returns Observable with result containing status snapshots
   */
  public execute(query: GetStatusSnapshotsQuery): Observable<GetStatusSnapshotsResult> {
    this._state.setLoadingStatusSnapshots(true);
    this._state.setErrorStatusSnapshots(null);

    return this._repository.getStatusSnapshots(query.caseId).pipe(
      tap((statusSnapshots) => {
        this._state.setStatusSnapshots(statusSnapshots);
        this._state.setLoadingStatusSnapshots(false);
      }),
      map((statusSnapshots) => ({ statusSnapshots })),
      catchError((error) => {
        this._state.setErrorStatusSnapshots(error.message || 'Failed to get status snapshots');
        this._state.setLoadingStatusSnapshots(false);
        return throwError(() => error);
      })
    );
  }
}
